import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /** Note found by search (preview before claim) */
  searchResult: null,
  /** Note applied to current bill as payment */
  claimedNote: null,
};

const creditNoteSlice = createSlice({
  name: "creditNote",
  initialState,
  reducers: {
    setCreditNoteSearchResult: (state, action) => {
      state.searchResult = action.payload;
    },
    setClaimedCreditNote: (state, action) => {
      state.claimedNote = action.payload;
    },
    clearCreditNoteSearch: (state) => {
      state.searchResult = null;
    },
    clearClaimedCreditNote: (state) => {
      state.claimedNote = null;
    },
    resetCreditNote: (state) => {
      state.searchResult = null;
      state.claimedNote = null;
    },
  },
});

export const {
  setCreditNoteSearchResult,
  setClaimedCreditNote,
  clearCreditNoteSearch,
  clearClaimedCreditNote,
  resetCreditNote,
} = creditNoteSlice.actions;

/** Amount applied to bill from a claimed credit/exchange note */
export const selectCreditNotePaymentAmount = (state) => {
  const note = state.creditNote?.claimedNote;
  if (!note) return 0;
  const amount = parseFloat(note.appliedAmount);
  return isNaN(amount) ? 0 : amount;
};

export const selectClaimedCreditNote = (state) => state.creditNote?.claimedNote;

export default creditNoteSlice.reducer;
